export const principlesData = [
  {
    id: 1,
    title: 'Sport',
    text: 'Open Tournaments but Closed Championships. National teams, ratings, titles.',
    conclusion: 'The laws of sports are above all!',
    iconsColor: 'pink',
  },
  {
    id: 2,
    title: 'Exclusivity',
    text: 'One organization per country. Certification of clubs, coaches, judges.',
    conclusion: 'Membership in the ECDS guarantees the quality of work.',
    iconsColor: 'blue',
  },
  {
    id: 3,
    title: 'Standardization',
    text: 'Single database, rules, requirements for tournaments, judges, dancers of all levels.',
    conclusion: 'Dance Europe is understandable and accessible.',
    iconsColor: 'lavender',
  },
  {
    id: 4,
    title: 'Win-win strategy',
    text: 'Comfort and respect. Long-term cooperation. Positive outcome for all parties.',
    conclusion: 'Everyone wins with us.',
    iconsColor: 'green',
  },
];
